import React from 'react';
import PropTypes from 'prop-types';

function MediaFilter({ filter, updateMediaTypeToFilter, mediaType }) {

  function linkClick(e, func){
    e.preventDefault();
    func();
  }

  const links = mediaType === filter.mediaType ?
    <span>{filter.displayName}</span> :
    <a href="#change-type"
      aria-controls="search-results"
      onClick={(e) => linkClick(e, updateMediaTypeToFilter)}
    >
    {filter.displayName}
    </a>;

  return links;
}

export default MediaFilter;

MediaFilter.propTypes = {
  filter: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    mediaType: PropTypes.string.isRequired
  }).isRequired,
  updateMediaTypeToFilter: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MediaFilter.js